import { useSyncExternalStore } from 'react'

export type NotesViewContext = {
  sourceEntity: string
  label?: string
  /** Required for the tickets tab on tenant pages. */
  tenantCuid?: string
}

let currentContext: NotesViewContext | null = null
const listeners = new Set<() => void>()

function emit(): void {
  listeners.forEach((listener) => listener())
}

function contextsEqual(a: NotesViewContext | null, b: NotesViewContext | null): boolean {
  if (a === b) return true
  if (a == null || b == null) return false
  return (
    a.sourceEntity === b.sourceEntity && a.label === b.label && a.tenantCuid === b.tenantCuid
  )
}

/** Called from record pages when notes context is available. Cleared on unmount or id mismatch. */
export function setNotesViewContext(context: NotesViewContext | null): void {
  if (contextsEqual(currentContext, context)) return
  currentContext = context
  emit()
}

export function getNotesViewContext(): NotesViewContext | null {
  return currentContext
}

export function subscribeNotesViewContext(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function useNotesViewContext(): NotesViewContext | null {
  return useSyncExternalStore(subscribeNotesViewContext, getNotesViewContext, () => null)
}
